import React, { useEffect, useState } from "react";
import {
  Alert,
  Row,
  Col,
  Form,
  Label,
  Button,
  UncontrolledTooltip,
} from "reactstrap";

import { getAuth, applyActionCode } from "firebase/auth";
import { useSearchParams } from "react-router-dom";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// config
import config from "../../config";

// hooks
import { useProfile, useRedux } from "../../hooks/index";
import { createSelector } from "reselect";
//actions
import { loginUser, socialLogin } from "../../redux/actions";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import FormInput from "../../components/FormInput";
import Loader from "../../components/Loader";

// services
import { loginUserAccount } from "../../services/auth";
import { generateJWT } from "../../api/auth";

import { useSnackbar } from "../../utils/snackbar";

// utils
import { redirectAfterDelay } from "../../utils/redirectAfterDelay";

interface LoginProps {}
interface LoginFormValues {
  email: string;
  password: string;
}

interface JwtTokenType {
  token: string;
}
const EmailVerification = (props: LoginProps) => {
  const [searchParams] = useSearchParams();
  const auth = getAuth();
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Login,
    state => ({
      isUserLogin: state.isUserLogin,
      error: state.error,
      loginLoading: state.loading,
      isUserLogout: state.isUserLogout,
    }),
  );
  // Inside your component
  const { isUserLogin, error, loginLoading, isUserLogout } =
    useAppSelector(errorData);

  const navigate = useNavigate();
  const location = useLocation();
  const showSnackbar = useSnackbar();
  const [redirectUrl, setRedirectUrl] = useState("/dashboard");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const mode = searchParams.get("mode");
    const oobCode = searchParams.get("oobCode");

    if (mode === "verifyEmail" && oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setAlertMessage("Email verified successfully!");
          setAlertType("success");
        })
        .catch(error => {
          setAlertMessage("Invalid Verificaton Link");
          setAlertType("danger");
        });
    }
  }, [searchParams, auth]);

  useEffect(() => {
    const url =
      location.state && location.state.from
        ? location.state.from.pathname
        : "/";
    setRedirectUrl(url);
  }, [location]);
  useEffect(() => {
    if (isUserLogin && !loginLoading && !isUserLogout) {
      navigate(redirectUrl);
    }
  }, [isUserLogin, navigate, loginLoading, isUserLogout, redirectUrl]);

  const resolver = yupResolver(
    yup.object().shape({
      email: yup.string().required("Please Enter E-mail."),
      password: yup.string().required("Please Enter Password."),
    }),
  );

  const methods = useForm({ resolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  const handleRedirect = () => {
    redirectAfterDelay(navigate, "/dashboard", 1000); // Redirects to "/target-page" after 3 seconds
  };

  const { userProfile, loading } = useProfile();

  if (userProfile && !loading) {
    return <Navigate to={{ pathname: redirectUrl }} />;
  }

  return (
    <NonAuthLayoutWrapper>
      {alertMessage && (
        <Alert color={alertType} toggle={() => setAlertMessage("")}>
          {alertMessage}
        </Alert>
      )}
      <Row className=" justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5} className="col-xxl-4">
          <div className="py-md-5 py-4">
            <AuthHeader
              title="Welcome Back !"
              subtitle="Sign in to continue to Invoice."
            />

            <div className="mt-5 text-center text-muted">
              <p>
                Do you want to login ?{" "}
                <Link
                  to="/auth-login"
                  className="fw-medium text-decoration-underline"
                >
                  {" "}
                  login
                </Link>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default EmailVerification;
